import { IApplicationDefinitionSummary } from '../application-definition/application-definition-summary';

export class EvaluationDefinitionSummary implements IApplicationDefinitionSummary {
  id: string;
  title: string;
  publicTitle: string;
  hasExpired: boolean;
  isArchived: boolean;
  workspaceId: string | null;

  constructor(evaluationDefinitionSummary: any = undefined) {
    if (evaluationDefinitionSummary) this.setProperties(evaluationDefinitionSummary);
  }

  private setProperties(evaluationDefinitionSummary: any) {
    this.id = evaluationDefinitionSummary.id;
    this.title = evaluationDefinitionSummary.title;
    this.publicTitle = evaluationDefinitionSummary.publicTitle;
    this.hasExpired = evaluationDefinitionSummary.hasExpired;
    this.isArchived = evaluationDefinitionSummary.isArchived;
    this.workspaceId = evaluationDefinitionSummary.workspaceId;
  }

  public static parse(data: any): EvaluationDefinitionSummary {
    if (!data) return null;

    let evaluation = new EvaluationDefinitionSummary();
    Object.assign(evaluation, data);

    return evaluation;
  }

  public isSharedFromOrg(isInOrg: boolean): boolean {
    return !isInOrg && !this.workspaceId;
  }
}
